import React from 'react';
const rungs = [{
  symbol: '▲',
  label: 'DO',
  tone: 'bg-sage text-white'
}, {
  symbol: '■',
  label: 'HELP',
  tone: 'bg-gold text-gold-ink'
}, {
  symbol: '●',
  label: 'FEEL',
  tone: 'bg-smoke text-white'
}];

/** The three rungs, with their symbols so the idea still reads in black and white. */
export function LadderLegend() {
  return <div className="flex flex-col items-center gap-2" data-id="element-133" data-mp="26bheewx16sl0">
      <ul className="flex items-center gap-2" aria-label="Do, Help, Feel" data-id="element-134" data-mp="2b9iura32odss">
        {rungs.map(r => <li key={r.label} className={`flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-bold tracking-wider ${r.tone}`} data-id="element-135" data-mp="2f9tcfk088snh">
            <span aria-hidden="true" data-id="element-136" data-mp="2p8ijsiuhyuph">{r.symbol}</span>
            {r.label}
          </li>)}
      </ul>
      <p className="text-center text-[13px] text-ink-soft" data-id="element-137" data-mp="pw69jit07p52">
        Every activity, written three ways for the same session.
      </p>
    </div>;
}